import React from 'react';

/**
 * KPI stat card on the design-system recipe (.admin-stat-card).
 * `value` renders "—" for null/undefined (source unavailable ≠ zero).
 */
export function StatCard({
  label,
  value,
  sub,
  children,
  className = '',
}: {
  label: string;
  value: number | string | null | undefined;
  sub?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}) {
  const display =
    value == null ? '—' : typeof value === 'number' ? value.toLocaleString() : value;
  return (
    <div className={`admin-stat-card min-w-0 ${className}`}>
      <div className="admin-stat-card__label">{label}</div>
      <div className="admin-stat-card__value">{display}</div>
      {sub ? <div className="mt-1.5 text-[11px] leading-snug text-mutedDim">{sub}</div> : null}
      {children}
    </div>
  );
}
